import { Actions, ActionTypes } from '../actions/employment';
import { Unit } from '../../settings-module/models/unit';

export interface State {
  userEmployments: any[];
  pagination: {};
  companyEmployments: any[];
  selectedUnit: Unit;
  selectedUnitId: number;
  errors: any[];
}

export const initialState: State = {
  userEmployments: null,
  pagination: null,
  companyEmployments: [],
  selectedUnit: null,
  selectedUnitId: null,
  errors: [],
};

export function employmentReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.LoadUserEmploymentsSuccess:
      return {
        ...state,
        userEmployments: action.payload.userEmployments,
        pagination: action.payload.pagination,
      };

    case ActionTypes.LoadCurrentUnit:
      return { ...state, selectedUnitId: action.payload.selectedUnitId };

    case ActionTypes.LoadCurrentUnitSuccess:
      return {
        ...state,
        selectedUnit: action.payload.selectedUnit,
      };

    case ActionTypes.LoadCompanyEmployments:
      return {
        ...state,
        companyEmployments: [],
        selectedCompanyId: action.payload.companyId,
      };

    case ActionTypes.LoadCompanyEmploymentsSuccess:
      return {
        ...state,
        companyEmployments: action.payload.companyEmployments,
      };

    case ActionTypes.LoadUserEmploymentsFail:
      return {
        ...state,
        errors: [...state.errors, ...action.payload.errors],
      };

    case ActionTypes.LoadEmploymentsFail:
    case ActionTypes.LoadCurrentUnitFail:
      return {
        ...state,
        errors: [...state.errors, ...action.payload.errors],
      };

    default:
      return state;
  }
}

export const getUserEmployments = (state: State) => state.userEmployments;
export const getUserEmploymentsPagination = (state: State) => state.pagination;
export const getCompanyEmployments = (state: State) => state.companyEmployments;
export const getSelectedUnit = (state: State) => state.selectedUnit;
export const getSelectedUnitId = (state: State) => state.selectedUnitId;
export const getEmploymentErrors = (state: State) => state.errors;
